import { render } from "./NoQuotesFound.vue?vue&type=template&id=2b381795"
import script from "./NoQuotesFound.vue?vue&type=script&lang=js"
export * from "./NoQuotesFound.vue?vue&type=script&lang=js"

import "./NoQuotesFound.vue?vue&type=style&index=0&id=2b381795&lang=css"

import exportComponent from "/home/newbuyanyinsuran/public_html/wizards/car.buyanyinsurance.ae/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__